import { fireLoginGAEvent } from '@global/gtm/base';

export function fireLoginEvent() {
  window.dataLayer = window.dataLayer || [];

  fireLoginGAEvent({
    actionType: '會員登入',
    loginType: 'EMAIL',
  });
}

export function fireLoginGTMEventByLINE() {
  window.dataLayer = window.dataLayer || [];

  fireLoginGAEvent({
    actionType: '會員登入',
    loginType: 'LINE',
  });
}

export function fireLoginGTMEventByFB() {
  window.dataLayer = window.dataLayer || [];

  fireLoginGAEvent({
    actionType: '會員登入',
    loginType: 'Facebook',
  });
}
